import Plausible from 'plausible-tracker'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal as MantineModal } from '@mantine/core'
import { useEvents, useMixPanel } from '@/features/app/hooks'
import { BookingConfirmedContainer } from '@/features/booking/components/BookingConfirmed'
import { checkoutState } from '@/features/booking/store/checkout.slice'
import { BOOKING_TYPE } from '@/features/bookings/consts/booking'
import { TAG_MANAGER_EVENT } from '@/features/tag-manager/consts/event'
import useStyles from './BookingModal.styles'

interface IProps {
  frame?: boolean
  onModalClode: () => void
  visible: boolean
}
export const BookingPaymentModal = ({ frame, visible, onModalClode }: IProps) => {
  const { classes } = useStyles()

  const dispatch = useDispatch()
  const events = useEvents()
  const { booking } = useSelector((state: any) => state.booking.checkout)
  const mixPanel = useMixPanel()
  const { trackEvent } = Plausible({
    domain: 'babysisters.pt',
  })
  //const [justCreatedUser, setJustCreatedUser] = useState(false)
  const [paymentConfirmed, setPaymentConfirmed] = useState(false)
  const [visibleLoginModal, setVisibleLoginModal] = useState(false)
  const [bookingId, setBookingId] = useState(null)
  const [bookingAdminEdited, setBookingAdminEdited] = useState(false)

  useEffect(() => {
    if (visible) {
      if (!frame) {
        setPaymentConfirmed(booking.payment_confirmed)
        const type = booking.type

        trackEvent(
          type === BOOKING_TYPE.ONETIME || type === BOOKING_TYPE.REGULAR
            ? 'booking/confirmed'
            : type + '/confirmed'
        )
        events.actions.confirmed({
          Booking: booking.id,
        })
      } else {
        setBookingId(booking.id)
        setBookingAdminEdited(booking.adminEdited)
        if (booking.isNewuser) {
          try {
            mixPanel.actions.reset()
            mixPanel.actions.identify(booking.user.id)
            mixPanel.actions.track(TAG_MANAGER_EVENT.REGISTER, {
              Type: 'Admin',
            })
            mixPanel.actions.track(TAG_MANAGER_EVENT.BOOKING_ADMIN, {
              Type: booking.type,
              Booking: booking.id,
            })
            mixPanel.actions.reset()
          } catch (e) {
            console.error('Error sending register event', e)
          }
        } else {
          if (!booking.adminEdited) {
            mixPanel.actions.reset()
            mixPanel.actions.identify(booking.user.id)
            mixPanel.actions.track(TAG_MANAGER_EVENT.BOOKING_ADMIN, {
              Type: booking.type,
              Booking: booking.id,
            })
            mixPanel.actions.reset()
          }
        }
      }
      if (!frame) {
        dispatch(checkoutState.setBooking(null))
      }
    }
  }, [visible])

  return (
    <>
      <MantineModal
        onClose={onModalClode}
        opened={visible}
        withCloseButton={false}
        closeOnEscape={false}
        closeOnClickOutside={false}
        centered
      >
        <div className={classes.wrap}>
          <BookingConfirmedContainer
            paymentConfirmed={paymentConfirmed}
            bookingId={bookingId}
            bookingAdminEdited={bookingAdminEdited}
            onPopupClose={onModalClode}
            frame={frame}
          />
        </div>
      </MantineModal>
    </>
  )
}
